import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import TabPanelHidden from "../../../../Components/TabPanelHidden";
import CreatorPfp from "../../../../Components/CreatorData/creatorPfp";
import CreatorInfo from "../../../../Components/CreatorData/creatorInfo";

function ProfilePaymentTab({
  tabValue,
  index,
  creatorName,
  setCreatorName,
  profilePhotoUrl,
  setIsUploadDialogOpen,
  creatorRegion,
  setCreatorRegion,
  race,
  setRace,
  gender,
  setGender,
  location,
  setLocation,
  primaryMarket,
  setPrimaryMarket,
  notesContentStyle,
  setNotesContentStyle,
  contactEmail,
  setContactEmail,
  phoneNumber,
  setPhoneNumber,
  validationError,
  paymentEmail,
  setPaymentEmail,
}) {
  return (
    <TabPanelHidden value={tabValue} index={index} id={`tab-contents-${index}`}>
      <CreatorPfp
        creatorName={creatorName}
        profilePhotoUrl={profilePhotoUrl}
        handleOpenUploadDialog={() => setIsUploadDialogOpen(true)}
      />

      <CreatorInfo
        creatorName={creatorName}
        setCreatorName={setCreatorName}
        creatorRegion={creatorRegion}
        setCreatorRegion={setCreatorRegion}
        race={race}
        setRace={setRace}
        gender={gender}
        setGender={setGender}
        location={location}
        setLocation={setLocation}
        primaryMarket={primaryMarket}
        setPrimaryMarket={setPrimaryMarket}
        notesContentStyle={notesContentStyle}
        setNotesContentStyle={setNotesContentStyle}
        contactEmail={contactEmail}
        setContactEmail={setContactEmail}
        phoneNumber={phoneNumber}
        setPhoneNumber={setPhoneNumber}
        validationError={validationError}
        require={false}
      />

      <Box sx={{ mt: 3, p: 2, border: "1px solid #ccc" }}>
        <Typography variant="h6" gutterBottom>
          Payment Information
        </Typography>
        <TextField
          fullWidth
          margin="dense"
          label="PayPal Payment Email"
          value={paymentEmail}
          onChange={(e) => setPaymentEmail(e.target.value)}
        />
      </Box>
    </TabPanelHidden>
  );
}

export default ProfilePaymentTab;
